module.exports = __webpack_public_path__ + "media/images/icon_list/design-ebea6ef034d06abe2c87cb0fc21f09dd.svg";